import { render } from "./ViewSubsection.vue?vue&type=template&id=5c22fbc6&scoped=true"
import script from "./ViewSubsection.vue?vue&type=script&lang=js"
export * from "./ViewSubsection.vue?vue&type=script&lang=js"

import "./ViewSubsection.vue?vue&type=style&index=0&id=5c22fbc6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c22fbc6"]])

export default __exports__